module.exports = __webpack_public_path__ + "img/QA_pin04.50b46e9e.svg";